/**
*
* AddMessage
*
*/

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';
import { Alert } from 'react-bootstrap';
import Input from 'components/tags/Input/index.jsx';
import messages from './messages.js';
import useFilterParticipants from './useFilterParticipants.js';
import InlineEdit from './InlineEdit/index.jsx';
import { FILTER_PARTICIPANTS_CURRENT_OTHER } from './constants.jsx';
import useConversationsContext from './useConversationsContext.js';
import OwnLanguagePrompt from './OwnLanguagePrompt.jsx';

function AddMessage(props) {
  const { editMessage, setEditMessage } = props;
  const { topic } = useConversationsContext();
  const filterParticipants = useFilterParticipants(true);
  const topicId = topic.id;
  const defaultPost = { topicId };
  const { loading, closed, permissions, participants } = topic;
  if (loading || !permissions || !topicId) {
    return null;
  }
  if (!participants || filterParticipants(participants, FILTER_PARTICIPANTS_CURRENT_OTHER).length === 0) {
    return <Alert variant="warning" className="mb-0"><FormattedMessage {...messages.noActiveParticipants} /></Alert>;
  }
  const disabled = Boolean(closed || !permissions.write);
  return editMessage ? (
    <>
      <OwnLanguagePrompt className="mx-3 mb-2 opacity-50" />
      <InlineEdit post={editMessage} onClose={() => setEditMessage(null)} />
    </>
  ) : (
    <Input type="text" placeholder={messages.addMessage} className="form-control mb-4" disabled={disabled} onFocus={() => setEditMessage(defaultPost)} />
  );
}

AddMessage.propTypes = {
  editMessage: PropTypes.object,
  setEditMessage: PropTypes.func.isRequired,
};

export default AddMessage;
